module.exports = __webpack_public_path__ + "r-v3/img/speaker_on_white.782ce076.svg";